import { Component, OnInit, Input } from '@angular/core';
import { InformationBoxService } from './information-box.service';
@Component({
    selector: 'information-box',
    templateUrl: './information-box.component.html',
    styleUrls: ['./information-box.component.scss']
})

export class InformationBoxComponent implements OnInit {
    _textoInfo: any;
    @Input() textoBox?: string;
    @Input() set textoInfo(value) {
        this._textoInfo = value;
    }

    @Input() cantidadBotones?;
    constructor(
        public _informationBoxService: InformationBoxService,
    ) { }

    ngOnInit(): void {
    }

    getClase() {
        if (this.cantidadBotones !== undefined) {
            return this.clasePorInput();
        } else {
            return this.clasePorServicio();
        }
    }

    clasePorServicio() {
        return {
            sinBotones: this._informationBoxService._botones === 0,
            unBoton: this._informationBoxService._botones === 1,
            unBoton_small: this._informationBoxService._botones === 11,
            dosBotones: this._informationBoxService._botones === 2,
            dosBotonesMedium: this._informationBoxService._botones === 21,
            dosBotones_big: this._informationBoxService._botones === 22,
            tresBotones: this._informationBoxService._botones === 3,
            cuatroBotones: this._informationBoxService._botones === 4,
            cincoBotones: this._informationBoxService._botones === 5,
            seisBotones: this._informationBoxService._botones === 6
        };
    }

    clasePorInput() {
        return {
            sinBotones: this.cantidadBotones === 0,
            unBoton: this.cantidadBotones === 1,
            unBoton_small: this.cantidadBotones === 11,
            dosBotones: this.cantidadBotones === 2,
            dosBotonesMedium: this.cantidadBotones === 21,
            dosBotones_big: this.cantidadBotones === 22,
            tresBotones: this.cantidadBotones === 3,
            cuatroBotones: this.cantidadBotones === 4,
            cincoBotones: this.cantidadBotones === 5,
            seisBotones: this.cantidadBotones === 6
        };
    }


}
